import { ReportFeatures } from '@hcs/types';

export const SUBJECT_PHOTO_CAROUSEL_FEATURES = [
  ReportFeatures.SubjectPhotosAll,
  ReportFeatures.SubjectPhotosCurrent,
  ReportFeatures.SubjectStreetview,
];
